module.exports = __webpack_public_path__ + "img/IMG_1945.10a51738.jpg";